import React from "react";

import { StyledTypography } from "./styles";
import { TypographyProps } from "./types";

/**
 * Componente Typography
 *
 * Renderiza textos estilizados com suporte para variantes, cores e responsividade.
 *
 * @param {keyof JSX.IntrinsicElements} [as='p'] - Define dinamicamente o elemento HTML.
 * @param {React.ReactNode} children - Conteúdo do texto.
 * @param {keyof typeof theme.colors} [color='darkGray'] - Nome da cor definida no tema.
 * @param {'left' | 'center' | 'right'} [align='left'] - Alinhamento do texto.
 * @param {keyof typeof theme.fontWeights} [weight='normal'] - Peso da fonte definido no tema.
 * @param {'h1' | 'h2' | 'h3' | 'body' | 'caption' | 'label'} [variant='body'] - Estilo tipográfico baseado nas variantes.
 * @param {boolean} [uppercase=false] - Define se o texto será renderizado em maiúsculas.
 * @param {boolean} [italic=false] - Define se o texto será renderizado em itálico.
 */
export const Typography: React.FC<TypographyProps> = ({
  children,
  as,
  color,
  ...props
}) => {
  return (
    <StyledTypography as={as} color={color} {...props}>
      {children}
    </StyledTypography>
  );
};
